export class ElementController {
    constructor(_parent, type) {
        this._parent = _parent;
        this._element = document.createElement(type);
    }
    get api() {
        return this._element;
    }
    get style() {
        return this._element.style;
    }
    set_attribute(attribute, value) {
        this._element.setAttribute(attribute, value);
    }
    get_attribute(attribute) {
        return this._element.getAttribute(attribute);
    }
    set_position(x, y) {
        this._element.setAttribute('x', x.toString());
        this._element.setAttribute('y', y.toString());
    }
    show() {
        if (!this._element.parentElement) {
            this._parent.appendChild(this._element);
        }
    }
    hide() {
        if (this._element.parentElement) {
            this._parent.removeChild(this._element);
        }
    }
}
//# sourceMappingURL=ElementController.js.map